// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.4";import * as Sentry from '@sentry/nextjs';

import { initSentryOnClient } from '@scorenco/sentry';

initSentryOnClient();

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
